module.exports = __webpack_public_path__ + "fonts/portmanteau.ef7657c5.ttf";